import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import classes from "./Countdown.module.scss";
import { selectStartTime, setStartTime } from "../store/bookingSlice";
import { DateTime, Duration } from "luxon";
import store from "../store";
import { Col, Row } from "react-bootstrap";

interface Props extends React.HTMLAttributes<HTMLElement> {
  minutes: number;
  seconds: number;
}

function Countdown(props: Props) {
  const navigate = useNavigate();
  const startTime = useSelector(selectStartTime);
  const [timeoutString, setTimeoutString] = React.useState<string>(
    `${props.minutes}:${props.seconds < 10 ? "0" : ""}${props.seconds}`
  );

  useEffect(() => {
    const updateTime = () => {
      if (startTime) {
        const remaining = Duration.fromObject({
          minutes: props.minutes,
          seconds: props.seconds,
        }).plus(DateTime.fromSeconds(startTime).diffNow());
        if (remaining.as("seconds") <= 0) {
          navigate("/");
        }
        setTimeoutString(remaining.toFormat("m:ss"));
      }
    };
    updateTime();
    const i = setInterval(updateTime, 1000);
    return () => clearInterval(i);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startTime]);

  return (
    <Row className={classes.countdown}>
      <Col xs={6} sm={12} className="text-end">
        Complete your booking in {timeoutString}
      </Col>
      <Col xs={6} sm={12} className={"text-end"}>
        <a
          href="/"
          onClick={(e) => {
            e.preventDefault();
            store.dispatch(setStartTime(DateTime.now().toUnixInteger()));
            setTimeoutString(
              Duration.fromObject({
                minutes: props.minutes,
                seconds: props.seconds,
              }).toFormat("m:ss")
            );
          }}
        >
          Extend your session
        </a>
      </Col>
    </Row>
  );
}

export default Countdown;
